import { render, staticRenderFns } from "./RealNameAuth.vue?vue&type=template&id=da552ad4&"
import script from "./RealNameAuth.vue?vue&type=script&lang=ts&"
export * from "./RealNameAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports